import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PLANE_PATH = 'M21,16V14L13,9V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V9L2,14V16L10,13.5V19L8,20.5V22L11.5,21L15,22V20.5L13,19V13.5L21,16Z';

const styles = `
	@keyframes global-spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
	@keyframes fade-glow {
		0%, 100% {
			opacity: 0.2;
			filter: drop-shadow(0 0 2px rgba(255,215,0,0.2));
		}
		50% {
			opacity: 1;
			filter: drop-shadow(0 0 12px rgba(255,215,0,1)) drop-shadow(0 0 20px rgba(212,175,55,0.6));
		}
	}
	@keyframes pulse-text {
		0%, 100% { opacity: 0.5; }
		50% { opacity: 1; }
	}
	.ldr-holder {
		position: absolute;
		width: 100%;
		height: 100%;
		animation: global-spin 4s linear infinite;
	}
	.ldr-plane-1 svg { animation: fade-glow 2s ease-in-out infinite; }
	.ldr-plane-2 svg { animation: fade-glow 2s ease-in-out infinite; animation-delay: 0.66s; }
	.ldr-plane-3 svg { animation: fade-glow 2s ease-in-out infinite; animation-delay: 1.33s; }
	.ldr-text {
		margin-top: 30px;
		color: #d4af37;
		font-size: 15px;
		letter-spacing: 4px;
		text-transform: uppercase;
		animation: pulse-text 1.5s ease-in-out infinite;
		font-family: 'Segoe UI', sans-serif;
	}
`;

const planeBase = {
	position: 'absolute',
	width: '100%',
	height: '100%',
	top: 0,
	left: 0,
};

const svgBase = {
	position: 'absolute',
	top: '0px',
	left: '50%',
	transform: 'translateX(-50%) rotate(90deg)',
	width: '40px',
	height: '40px',
	fill: '#ffd700',
};

const Loading = () => {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const next = params.get('next') || '/';
		const t = setTimeout(() => navigate(next, { replace: true }), 3000);
		return () => clearTimeout(t);
	}, [location.search, navigate]);

	return (
		<div style={ {
			margin: 0, padding: 0,
			width: '100vw', height: '100vh',
			display: 'flex', flexDirection: 'column',
			justifyContent: 'center', alignItems: 'center',
			backgroundColor: '#0b0c10',
			overflow: 'hidden',
			position: 'fixed', inset: 0, zIndex: 9999,
		} }>
			<style>{ styles }</style>

			<div style={ { position: 'relative', width: 240, height: 240, display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
				{/* Dashed orbit ring */ }
				<div style={ {
					position: 'absolute', width: 200, height: 200,
					borderRadius: '50%',
					border: '2px dashed rgba(212,175,55,0.2)',
				} } />

				{/* Spinning plane holder */ }
				<div className="ldr-holder">
					<div className="ldr-plane-1" style={ { ...planeBase, transform: 'rotate(0deg)' } }>
						<svg style={ svgBase } viewBox="0 0 24 24"><path d={ PLANE_PATH } /></svg>
					</div>
					<div className="ldr-plane-2" style={ { ...planeBase, transform: 'rotate(120deg)' } }>
						<svg style={ svgBase } viewBox="0 0 24 24"><path d={ PLANE_PATH } /></svg>
					</div>
					<div className="ldr-plane-3" style={ { ...planeBase, transform: 'rotate(240deg)' } }>
						<svg style={ svgBase } viewBox="0 0 24 24"><path d={ PLANE_PATH } /></svg>
					</div>
				</div>
			</div>

			<div className="ldr-text">Đang kết nối hệ thống...</div>
		</div>
	);
};

export default Loading;
